module.exports = __webpack_public_path__ + "img/lite.542e30e2.jpg";